import { isEqual } from 'lodash';

import { initialState as initialBooking } from '../store/bookingSlice';
import { initialState as initialGroup } from '../store/groupDetailsSlice';
import { useAppSelector } from '../store/store';

import { useLocation } from './navigation';
import { useHotelUnsavedChanges } from './session';

export function hasHotelSearchSelections(pathname: string, search: string) {
  if (
    !/^\/(dashboard|search|groups|shortlist|group_request|selfbooking)(\/|$)/.test(
      pathname,
    )
  )
    return false;
  const params = new URLSearchParams(search);
  return ['latitude', 'longitude', 'checkInDate', 'checkOutDate'].some((key) =>
    Boolean(params.get(key)),
  );
}

/** Server-loaded identity/configuration and ordinary list filters are not drafts. */
export function HotelDraftChanges() {
  const location = useLocation();
  const storedSelections = useAppSelector(
    ({ booking, groupDetails }) =>
      !isEqual(booking, initialBooking) || !isEqual(groupDetails, initialGroup),
  );
  useHotelUnsavedChanges(
    storedSelections ||
      hasHotelSearchSelections(location.pathname, location.search) ||
      (location.pathname === '/selfbooking' && location.state != null),
  );
  return null;
}
